/**
 * 评价信息
 */
import React from "react";
import PropTypes from "prop-types";
import Rating from "@components/rating";

const CommentsInfo = ({ commentsInfo }) => (
  <div
    className="comments-info"
    itemProp="aggregateRating"
    itemScope={true}
    itemType="http://schema.org/AggregateRating"
  >
    <div className="comments-info__count">
      共<span itemProp="reviewCount">{commentsInfo.count}</span>条评价
    </div>
    <Rating value={commentsInfo.totalScore} />
    <span>
      <span itemProp="ratingValue">{(commentsInfo.totalScore / 10).toFixed(1)}</span>分
    </span>
    <ul className="comments-info-grid list-unstyled clearfix">
      {commentsInfo.scoreItemModels.map(item => (
        <li key={`comments-info__items-${item.scoreItemId}`} className="col-sm-6 comments-info-grid__item">
          <span className="comments-info__text">{item.displayText}</span>
          <Rating className="comments-info__rating" value={item.score} />
          <span className="comments-info__score">{(item.score / 10).toFixed(1)}分</span>
        </li>
      ))}
    </ul>
  </div>
);

CommentsInfo.propTypes = {
  commentsInfo: PropTypes.object.isRequired,
};

export default CommentsInfo;

require("./index.less");
require("./index.less");